var styles = {
  "SkeletonBodyText": "Polaris-SkeletonBodyText"
};

export { styles as default };
